import { create } from "zustand";

export type Permission = {
  resource: string;
  action: string;
  active?: boolean | undefined;
};

type PermissionSnapshot = {
  permissions?: Permission[] | null;
  role?: string | null;
};

export const usePermissionStore = create<{
  permissions: Permission[];
  role: string;
  email: string;
  name: string;
  isPermissionsLoaded: boolean;
  permissionsDatasetId: string | null;
  setRole: (role: string) => void;
  setUserEmail: (email: string) => void;
  setUserName: (name: string) => void;
  setPermissions: (permissions: Permission[]) => void;
  hydratePermissions: (input: {
    permissions: Permission[];
    role: string;
    email: string;
    name: string;
    datasetId: string | null;
  }) => void;
}>((set, get) => ({
  // Initial States
  permissions: [],
  role: "",
  email: "",
  name: "",
  isPermissionsLoaded: false,
  permissionsDatasetId: null,
  setPermissions: (permissions: Permission[]) => set({ permissions: permissions }),
  setRole: (role: string) => set({ role: role }),
  setUserEmail: (email: string) => set({ email: email }),
  setUserName: (name: string) => set({ name: name }),
  hydratePermissions: ({ permissions, role, email, name, datasetId }) =>
    set({
      permissions,
      role,
      email,
      name,
      isPermissionsLoaded: true,
      permissionsDatasetId: datasetId,
    }),
}));

export const hasPermission = (state: PermissionSnapshot, resource: string, action: string) => {
  return (
    state.role === "Administrator" ||
    !!state.permissions?.some(
      (item) => item.resource === resource && (item.action === action || item.action === "*") && item.active,
    )
  );
};

export const useHasPermission = (resource: string, action: string) =>
  usePermissionStore((state) => hasPermission(state, resource, action));

export const checkPermission = (resource: string, action: string) => {
  return hasPermission(usePermissionStore.getState(), resource, action);
};
